"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("../index"));
var transifex_1 = require("../../../transifex");
var InquiryStatusTag = function (_a) {
    var _b = _a.closable, closable = _b === void 0 ? false : _b, closeIcon = _a.closeIcon, icon = _a.icon, _c = _a.visible, visible = _c === void 0 ? true : _c, onClose = _a.onClose, title = _a.title;
    var tagColor;
    var formattedTitle;
    formattedTitle = transifex_1.TX_NONE;
    // TODO: VR Added default value for switch, otherwise no point of using switch at all
    // eslint-disable-next-line default-case
    switch (title) {
        case "new":
            tagColor = "blue";
            formattedTitle = transifex_1.TX_NEW;
            break;
        case "rejected":
            tagColor = "red";
            formattedTitle = transifex_1.TX_REJECTED;
            break;
        case "accepted-add-to-route":
            tagColor = "green";
            formattedTitle = transifex_1.TX_ACCEPTED_ADD_TO_ROUTE;
            break;
        case "accepted":
            tagColor = "green";
            formattedTitle = transifex_1.TX_ACCEPTED;
            break;
        case "completed":
            tagColor = "lime";
            formattedTitle = transifex_1.TX_COMPLETED;
            break;
    }
    return (react_1.default.createElement(index_1.default, { closable: closable, closeIcon: closeIcon, color: tagColor, icon: icon, visible: visible, onClose: onClose, title: formattedTitle }));
};
exports.default = InquiryStatusTag;
